var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rapi-doc',_vm._b({attrs:{"goto-path":_vm.goToHash,"spec-url":_vm.docUrl,"render-style":"read"}},'rapi-doc',Object.assign({}, _vm.config),false))}
var staticRenderFns = []

export { render, staticRenderFns }